import styled from 'styled-components';

export const VerifyEmailStyles = styled.div`
  .verify-email-container {
    margin-top: 50px;
    width: 30%;
    min-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;

    .status-text {
      font-weight: bold;
    }

    .error-message {
      color: #c00;
      font-weight: bold;
      font-size: 0.9rem;
    }
  }
`;
